
export type AddMessageReactionBody = {
  reactionType: string;
};
